import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useNfuEntregadosMesyPorTipo from "../../hooks/punto_generacion/useNfuEntregadosMesyPorTipo";
import { getNfuEntregadosMesyPorTipo } from "../../utils/punto_generacion/chart_nfu_entregados_mes_y_por_tipo";
import "../../styles/graficas.css";

const NfuEntregadosPorTipoDeAprovechamiento = ({ year, token, idPuntoGeneracion }) => {
  const chartRef = useRef(null);
  const data = useNfuEntregadosMesyPorTipo(year, token, idPuntoGeneracion);

  useEffect(() => {
    if (Array.isArray(data) && data.length && chartRef.current) {
    if (data.length && chartRef.current) {
      const chartDom = chartRef.current;
      let myChart = echarts.init(chartRef.current);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      const updateChart = () => {
        myChart.setOption(getNfuEntregadosMesyPorTipo(data));
        myChart.resize();
      };
  
       
      updateChart();
  
      window.addEventListener("resize", updateChart);
      return () => {
        window.removeEventListener("resize", updateChart);
        myChart.dispose();
      };
    }
  }
  }, [data]);

  return <div className="grafica" ref={chartRef}></div>;
};

export default NfuEntregadosPorTipoDeAprovechamiento;